import useAuth from "../hooks/auth_hook";
import React, { createContext, useState } from "react";
import { Button } from "../components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../components/ui/dialog";
// Creating the context
export const APIContext = createContext<any>(null);

type APIContextType = {
    // Add the types of the context here
    children: React.ReactNode;
};

function fetch_api_dummy(endpoint: string, options: any) {
    let endpoint_dummy = endpoint.includes("/api") ? endpoint.split("/api")[1] : endpoint;
    // console.log({endpoint_dummy});
    const API_URL = process.env.REACT_APP_API_URL;
    // const user_sub = "google-oauth2|115338943426723721191";
    // const user_sub = "google-oauth2|104934464132002702552";
    const user_sub = "google-oauth2|114249137284625465995";
    options.headers = {
        ...options.headers,
        User: user_sub
    };
    console.log("API Call: Endpoint and Options");
    console.log(endpoint);
    console.log(options);
    return fetch(new URL(endpoint_dummy, API_URL), options)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        })
        .then((data) => {
            return data;
        });
}

const APIProvider = (props: APIContextType) => {
    const {children} = props;
    const {user, loginWithRedirect} = useAuth();
    const [reauthRequired, setReauthRequired] = useState(false);

    const fetch_api = React.useCallback(
        (endpoint: string, options: any) => {
            // Guard against undefined endpoint
            if (!endpoint) return Promise.reject(new Error("Endpoint is undefined"));

            // Check if user is available when not in debug mode
            if (!user && process.env.REACT_APP_API_DEBUG !== "true") {
                return Promise.reject(new Error("User not available"));
            }

            // Get the endpoint path without "/api" prefix if it exists
            const endpoint_no_api = endpoint.includes("/api") ? endpoint.split("/api")[1] : endpoint;
            const API_URL = process.env.REACT_APP_API_URL;

            if (!API_URL) {
                return Promise.reject(new Error("API URL is not defined"));
            }

            // Prepare headers
            const headers = {
                ...options.headers,
                User: user?.sub || "debug-user"
            };

            // Construct the request
            const requestOptions = {
                ...options,
                headers
            };

            // Make the fetch call
            return fetch(new URL(endpoint_no_api, API_URL), requestOptions)
                .then(async (response) => {
                    if (response.status === 401) {
                        const data = await response.json();
                        if (data.reauth_required) {
                            setReauthRequired(true);
                        }
                        throw new Error(data.error || response.statusText);
                    }
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                });
        },
        [user]
    );

    // Use debug version if in debug mode
    const finalFetchApi = process.env.REACT_APP_API_DEBUG === "true"
        ? fetch_api_dummy
        : fetch_api;

    return (
        <APIContext.Provider
            value={{
                fetch_api: finalFetchApi
            }}
        >
            {children}
            <Dialog open={reauthRequired} onOpenChange={setReauthRequired}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>YouTube Connection Expired</DialogTitle>
                        <DialogDescription>
                            Your YouTube connection has expired and needs to be refreshed.
                            Sign in again to restore access.
                            Dismiss if you are currently working on a test, as test progress is not saved until deployment.
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter>
                        <Button variant="outline" onClick={() => setReauthRequired(false)}>
                            Dismiss
                        </Button>
                        <Button onClick={() => loginWithRedirect()}>
                            Sign In Again
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </APIContext.Provider>
    );
};

export default APIProvider;